// Import supported languages
import UI_ar from "./ar/translation.json";
import UI_az from "./az/translation.json";
import UI_de from "./de/translation.json";
import UI_en from "./en/translation.json";
import UI_es from "./es/translation.json";
import UI_fr from "./fr/translation.json";
import UI_it from "./it/translation.json";
import UI_ja from "./ja/translation.json";
import UI_ka from "./ka/translation.json";
import UI_ko from "./ko/translation.json";
import UI_nl from "./nl/translation.json";
import UI_pl from "./pl/translation.json";
import UI_pt from "./pt/translation.json";
import UI_ro from "./ro/translation.json";
import UI_tr from "./tr/translation.json";
import UI_uk from "./uk/translation.json";
import UI_vi from "./vi/translation.json";
import UI_zh from "./zh/translation.json";
import UI_zu from "./zu/translation.json";

const locales = {
  ar: UI_ar,
  az: UI_az,
  de: UI_de,
  en: UI_en,
  es: UI_es,
  fr: UI_fr,
  it: UI_it,
  ja: UI_ja,
  ka: UI_ka,
  ko: UI_ko,
  nl: UI_nl,
  pl: UI_pl,
  ro: UI_ro,
  pt: UI_pt,
  tr: UI_tr,
  uk: UI_uk,
  vi: UI_vi,
  zh: UI_zh,
  zu: UI_zu,
};

export default locales;
